import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

// 加载所有模块
const modules = (function () {
  const context = require.context('./modules', false, /([a-z_]+)\.js$/i)
  const modules = context
    .keys()
    .map((key) => ({
      key,
      name: key.match(/([a-z_]+)\.js$/i)[1]
    })).reduce((modules, {
      key,
      name
    }) => ({
      ...modules,
      [name]: context(key).default
    }), {})
  return modules
})()
// 注册Vuex到vue
Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  getters
})
